export const vittime = [
  // Stagione Pre-Serie / menzioni
  {
    nome: 'Mary (l’infermiera)',
    descrizione: 'Prima vittima conosciuta di Dexter Morgan, uccisa prima degli eventi narrati nella serie. Dexter la cita come uno dei suoi primi omicidi, avvenuto quando stava ancora consolidando il Codice insegnatogli da Harry.',
    stagione: 'Pre-Serie'
  },
  {
    nome: 'Wiggles the Clown',
    descrizione: 'Serial killer di bambini ucciso da Dexter prima dell’inizio della serie. Viene menzionato come uno dei casi più evidenti che soddisfacevano pienamente i criteri del Codice.',
    stagione: 'Pre-Serie'
  },

  // Stagione 1
  {
    nome: 'Mike Donovan',
    descrizione: 'Pastore e serial killer di bambini. Dexter lo identifica grazie alle prove raccolte dalla polizia e lo uccide seguendo il rituale completo. È la prima vittima mostrata esplicitamente nella serie.',
    stagione: '1'
  },
  {
    nome: 'Jamie Jaworski',
    descrizione: 'Assassino colpevole della morte di una giovane donna, rilasciato per un vizio di forma. Dexter lo uccide nel suo appartamento, rafforzando la sua convinzione di essere necessario quando la giustizia fallisce.',
    stagione: '1'
  },
  {
    nome: 'Matt Chambers',
    descrizione: 'Assassino recidivo responsabile di più morti causate dalla guida in stato di ebbrezza. Dexter lo considera pericoloso per la totale assenza di rimorso.',
    stagione: '1'
  },
  {
    nome: 'Jorge Castillo',
    descrizione: 'Trafficante di esseri umani che sfruttava immigrati clandestini. Dexter lo uccide nel suo deposito dopo aver scoperto le condizioni disumane delle vittime.',
    stagione: '1'
  },
  {
    nome: 'Valerie Castillo',
    descrizione: 'Moglie e complice di Jorge Castillo. Partecipava consapevolmente al traffico di esseri umani e viene uccisa insieme al marito.',
    stagione: '1'
  },
  {
    nome: 'Alex Timmons',
    descrizione: 'Ex cecchino militare che uccideva civili per puro piacere dopo il congedo. Dexter lo vede come un esempio di killer senza freni morali.',
    stagione: '1'
  },
  {
    nome: 'Cindy Landon',
    descrizione: 'Serial killer che uccideva i mariti per incassare le assicurazioni sulla vita. Dexter scopre il suo schema e la elimina dopo averne confermato la serialità.',
    stagione: '1'
  },
  {
    nome: 'Brian Moser (Killer del Camion Frigo)',
    descrizione: 'Fratello biologico di Dexter, separato da lui dopo il trauma infantile. Dopo aver rivelato la verità sulle origini di Dexter e minacciato Debra, viene ucciso da Dexter per proteggerla.',
    stagione: '1'
  },

  // Stagione 2
  {
    nome: 'Little Chino',
    descrizione: 'Violento sicario di una gang criminale. Sopravvive a un primo tentativo di Dexter, ma viene successivamente catturato e ucciso seguendo il rituale.',
    stagione: '2'
  },
  {
    nome: 'Roger Hicks',
    descrizione: 'Venditore di auto che rapiva e uccideva donne bionde. Dexter lo affronta e lo uccide nel suo ufficio dopo aver raccolto prove decisive.',
    stagione: '2'
  },
  {
    nome: 'Ken Olson',
    descrizione: 'Imitatore che cercava di replicare i delitti attribuiti al Macellaio di Bay Harbor, mettendo a rischio la copertura di Dexter.',
    stagione: '2'
  },
  {
    nome: 'Santos Jimenez',
    descrizione: 'Uno dei criminali responsabili dell’uccisione e dello smembramento della madre di Dexter. La sua morte rappresenta una vendetta profondamente personale.',
    stagione: '2'
  },
  {
    nome: 'Jose Rodriguez',
    descrizione: 'Assassino e torturatore catturato da Dexter durante le indagini legate al Macellaio di Bay Harbor.',
    stagione: '2'
  },
  {
    nome: 'Esteban Famosa',
    descrizione: 'Trafficante di droga coinvolto nel rapimento del sergente Doakes. Dexter lo uccide per impedire che Doakes venga trasferito o eliminato.',
    stagione: '2'
  },
  {
    nome: 'Teo Famosa',
    descrizione: 'Fratello di Esteban. Dexter lo uccide nelle Everglades mentre cerca di rintracciare Doakes.',
    stagione: '2'
  },
  {
    nome: 'Lila West',
    descrizione: 'Ex amante di Dexter, emotivamente instabile. Dopo aver ucciso Doakes e tentato di incendiare i figli di Rita, Dexter la rintraccia a Parigi e la uccide.',
    stagione: '2'
  },
  {
    nome: 'Sergente James Doakes',
    descrizione: 'Vittima indiretta - Sergente della Omicidi che scopre la vera identità di Dexter come Macellaio di Bay Harbor. Viene tenuto prigioniero da Dexter e muore per mano di Lila West.',
    stagione: '2'
  },

  // Stagione 3
  {
    nome: 'Oscar Prado',
    descrizione: 'Fratello di Miguel Prado. Dexter lo uccide accidentalmente durante una colluttazione, evento che segna profondamente la stagione.',
    stagione: '3'
  },
  {
    nome: 'Fred “Freebo” Bowman',
    descrizione: 'Spacciatore e assassino coinvolto nella morte di una giovane informatrice. La sua uccisione lega Dexter al procuratore Miguel Prado.',
    stagione: '3'
  },
  {
    nome: 'Nathan Marten',
    descrizione: 'Pedofilo che perseguitava la figlia di Rita. Dexter lo uccide impulsivamente, infrangendo il Codice.',
    stagione: '3'
  },
  {
    nome: 'Ethan Turner',
    descrizione: 'Serial killer che uccideva le mogli durante i viaggi di nozze. Dexter lo elimina dopo averne confermato il modus operandi.',
    stagione: '3'
  },
  {
    nome: 'Clemson Galt',
    descrizione: 'Assassino fuggitivo ucciso da Dexter su richiesta di Miguel Prado, segnando la deriva morale di quest’ultimo.',
    stagione: '3'
  },
  {
    nome: 'Camilla Figg',
    descrizione: 'Amica di famiglia e figura materna per Dexter. Malata terminale, chiede a Dexter di porre fine alle sue sofferenze.',
    stagione: '3'
  },
  {
    nome: 'Miguel Prado',
    descrizione: 'Procuratore distrettuale che diventa alleato di Dexter ma infrange il Codice uccidendo per interesse personale. Dexter lo elimina per fermarlo.',
    stagione: '3'
  },

  // Stagione 4
  {
    nome: 'Rita Bennett',
    descrizione: 'Vittima indiretta - Moglie di Dexter e madre di suo figlio Harrison. Viene uccisa da Arthur Mitchell come ritorsione indiretta contro Dexter. La sua morte è una conseguenza diretta delle scelte di Dexter, che ha sottovalutato il pericolo rappresentato dal Killer della Trinità.',
    stagione: '4'
  },
  {
    nome: 'Benito Gomez',
    descrizione: 'Assassino violento che Dexter uccide in un magazzino dopo averne confermato la pericolosità.',
    stagione: '4'
  },
  {
    nome: 'Zoey Kruger',
    descrizione: 'Poliziotta che ha ucciso marito e figlia per ricostruirsi una nuova identità. Dexter la elimina seguendo il Codice.',
    stagione: '4'
  },
  {
    nome: 'Jonathan Farrow',
    descrizione: 'Fotografo ucciso erroneamente da Dexter, che credeva fosse un serial killer. La sua morte genera forte senso di colpa.',
    stagione: '4'
  },
  {
    nome: 'Arthur Mitchell (Trinity Killer)',
    descrizione: 'Serial killer responsabile di decine di omicidi rituali. Dexter lo uccide dopo una lunga osservazione, sottovalutandone però l’impatto sulla propria famiglia.',
    stagione: '4'
  },

  // Stagione 5
  {
    nome: 'Boyd Fowler',
    descrizione: 'Uomo che sigillava donne morte in barili. La sua uccisione porta Dexter a conoscere Lumen Pierce.',
    stagione: '5'
  },
  {
    nome: 'Dan Mendell',
    descrizione: 'Membro del gruppo criminale di Jordan Chase, ucciso in una stazione di servizio.',
    stagione: '5'
  },
  {
    nome: 'Cole Harmon',
    descrizione: 'Responsabile della sicurezza di Jordan Chase, eliminato in un hotel.',
    stagione: '5'
  },
  {
    nome: 'Stan Liddy',
    descrizione: 'Ex poliziotto che scopre il segreto di Dexter e inizia a ricattarlo. Muore durante una colluttazione con Dexter, evento innescato direttamente dal tentativo di Dexter di proteggere la propria identità.',
    stagione: '5'
  },
  {
    nome: 'Jordan Chase',
    descrizione: 'Leader carismatico e mandante di stupri e omicidi. Viene ucciso da Lumen con il supporto di Dexter.',
    stagione: '5'
  },
  {
    nome: 'Joe Walker',
    descrizione: 'Altro membro del gruppo di stupratori guidato da Jordan Chase.',
    stagione: '5'
  },

  // Stagione 6
  {
    nome: 'Roger Dunham',
    descrizione: 'Assassino intercettato e ucciso da Dexter all’inizio della sesta stagione.',
    stagione: '6'
  },
  {
    nome: 'Walter Kenney (La Fatina dei Denti)',
    descrizione: 'Serial killer in pensione che collezionava denti umani come trofei. Dexter lo uccide dopo averlo rintracciato.',
    stagione: '6'
  },
  {
    nome: 'Nick',
    descrizione: 'L’uomo che ha ucciso Fratello Sam. Dexter lo annega in un impeto di rabbia.',
    stagione: '6'
  },
  {
    nome: 'Travis Marshall (Il Killer dell’Apocalisse)',
    descrizione: 'Assassino fanatico religioso convinto di agire per volontà divina. Viene ucciso da Dexter davanti a Debra.',
    stagione: '6'
  },

  // Stagione 7
  {
    nome: 'Viktor Baskov',
    descrizione: 'Mafioso ucraino ucciso da Dexter per vendicare l’agente Mike Anderson.',
    stagione: '7'
  },
  {
    nome: 'Ray Speltzer',
    descrizione: 'Serial killer che costringeva le vittime a combattere in un labirinto. Dexter lo uccide e ne distrugge il corpo.',
    stagione: '7'
  },
  {
    nome: 'Oleg Ignotov',
    descrizione: 'Sicario della mafia russa eliminato da Dexter nel conflitto con la criminalità organizzata.',
    stagione: '7'
  },
  {
    nome: 'Capitano Maria LaGuerta',
    descrizione: 'Vittima indiretta - Capitano della polizia di Miami che riapre il caso del Macellaio di Bay Harbor e scopre la verità su Dexter. Viene uccisa da Debra per proteggere Dexter.',
    stagione: '7'
  },

  // Stagione 8
  {
    nome: 'Hector Estrada',
    descrizione: 'Ultimo dei responsabili dell’uccisione della madre di Dexter. Viene giustiziato come atto di chiusura personale.',
    stagione: '8'
  },
  {
    nome: 'Andrew Briggs',
    descrizione: 'Ladro ucciso accidentalmente da Dexter durante una colluttazione per proteggere Debra.',
    stagione: '8'
  },
  {
    nome: 'A.J. Yates',
    descrizione: 'Paziente della dottoressa Vogel che uccideva donne seguendo un feticismo ossessivo per le scarpe.',
    stagione: '8'
  },
  {
    nome: 'Oliver Saxon (Il Chirurgo del Cervello)',
    descrizione: 'Serial killer e figlio della dottoressa Vogel. Dexter lo uccide in una cella con un oggetto improvvisato.',
    stagione: '8'
  },
  {
    nome: 'Debra Morgan',
    descrizione: 'Vittima indiretta - Dopo essere stata gravemente ferita da Oliver Saxon mentre protegge Dexter, entra in uno stato vegetativo irreversibile. Dexter decide di staccare il supporto vitale.',
    stagione: '8'
  },

  // Stagione 9 / New Blood
  {
    nome: 'Matt Caldwell',
    descrizione: 'Figlio di Kurt Caldwell. Dexter lo uccide dopo aver scoperto il suo coinvolgimento in un omicidio, ponendo fine a dieci anni di astinenza.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Jasper Hodge',
    descrizione: 'Spacciatore responsabile di diverse overdose tra i ragazzi di Iron Lake. Dexter lo uccide per proteggere la comunità.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Kurt Caldwell',
    descrizione: 'Serial killer che uccideva giovani donne fuggitive. Viene ucciso da Dexter davanti al figlio Harrison.',
    stagione: '9 (New Blood)'
  },
  {
    nome: 'Sergente Logan',
    descrizione: 'Poliziotto innocente ucciso da Dexter durante un tentativo di fuga dalla prigione.',
    stagione: '9 (New Blood)'
  },

  // Vittime aggiunte dai wiki / fan
  {
    nome: 'Gene Marshall',
    descrizione: 'Nome citato in elenchi non ufficiali di vittime attribuite a Dexter, senza conferma diretta nella serie.',
    stagione: 'non specificata'
  },
  {
    nome: 'Emmett Meridian',
    descrizione: 'Assassino menzionato in liste secondarie di vittime, non mostrato direttamente nella serie.',
    stagione: 'non specificata'
  },
  {
    nome: 'George King',
    descrizione: 'Nome ricorrente in elenchi fan-made di vittime attribuite a Dexter.',
    stagione: 'non specificata'
  },
  {
    nome: 'Steve Dorsey',
    descrizione: 'Nome presente in database non ufficiali di vittime legate al personaggio di Dexter.',
    stagione: 'non specificata'
  },
  {
    nome: 'Jose Garza',
    descrizione: 'Nome citato in alcune liste di vittime senza riferimenti diretti negli episodi.',
    stagione: 'non specificata'
  },
  {
    nome: 'Juan Ryness',
    descrizione: 'Nome riportato in elenchi community di vittime attribuite a Dexter.',
    stagione: 'non specificata'
  },
  {
    nome: 'Lance Robinson',
    descrizione: 'Nome presente in liste fan delle vittime, senza apparizioni canoniche.',
    stagione: 'non specificata'
  },
  {
    nome: 'Beth Dorsey',
    descrizione: 'Nome segnalato in database non ufficiali relativi alle vittime di Dexter.',
    stagione: 'non specificata'
  },
  {
    nome: 'Clint McKay',
    descrizione: 'Nome citato in alcune liste di vittime non confermate nella serie.',
    stagione: 'non specificata'
  },
  {
    nome: 'Elric Kane',
    descrizione: 'Ex militare e sicario al servizio di Kurt Caldwell, ucciso durante gli eventi di New Blood.',
    stagione: '9 (New Blood)'
  }
]
